<post-fnol [postFnolData]="postFnolData | async" [previousUrl]="previousUrl | async"></post-fnol>
